import React from 'react';
import { Navigate, useNavigate } from 'react-router';

import { useEffect, useState, useRef } from 'react';

import { useAuthentication } from '../hooks/useAuthentication';
import { DropPage } from '../components';

interface CallbackState {
  error: Error | null;
  complete: boolean;
}

const Callback = () => {
  const { auth } = useAuthentication();
  const navigate = useNavigate();

  // In development, React.StrictMode renders twice, which is theoretically possible in prod as well, so we must guard this
  const inProgress = useRef(false);
  const [isLoaded, setIsLoaded] = useState(true);
  const [state, setState] = useState<CallbackState>({
    error: null,
    complete: false,
  });

  useEffect(() => {
    const parse = async () => {
      if (inProgress.current || !isLoaded) return;
      inProgress.current = true;
      try {
        await auth.parseRedirect();
        if (isLoaded) {
          setState({ error: null, complete: true });
        }
      } catch (e) {
        if (isLoaded && e instanceof Error) {
          setState({ error: e, complete: true });
        }
      } finally {
        inProgress.current = false;
      }
    };
    parse();
    return () => {
      setIsLoaded(false);
    };
  }, [setState, setIsLoaded]);

  useEffect(() => {
    if (auth.isUserSignedIn() && auth.isBasicUser()) {
      navigate('/app/activecase');
    }
  }, [auth, navigate]);

  if (state.error) {
    return <Navigate to="/" />;
  }

  return <DropPage>Logging you in...</DropPage>;
};

export default Callback;
